var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ZonedTime_plainTime, _ZonedTime_timeZone;
import { Temporal } from '@js-temporal/polyfill';
import { parseZonedTimeLike, } from './parse-zoned-time-string.js';
export class ZonedTime {
    constructor(isoHour = 0, isoMinute = 0, isoSecond = 0, isoMillisecond = 0, isoMicrosecond = 0, isoNanosecond = 0, timeZone = 'UTC') {
        _ZonedTime_plainTime.set(this, void 0);
        _ZonedTime_timeZone.set(this, void 0);
        __classPrivateFieldSet(this, _ZonedTime_plainTime, new Temporal.PlainTime(isoHour, isoMinute, isoSecond, isoMillisecond, isoMicrosecond, isoNanosecond), "f");
        __classPrivateFieldSet(this, _ZonedTime_timeZone, new Temporal.TimeZone(timeZone), "f");
    }
    static from(thing) {
        const { hour, minute, second, millisecond, microsecond, nanosecond, timeZone, } = parseZonedTimeLike(thing);
        return new ZonedTime(hour, minute, second, millisecond, microsecond, nanosecond, timeZone);
    }
    get hour() {
        return __classPrivateFieldGet(this, _ZonedTime_plainTime, "f").hour;
    }
    get minute() {
        return __classPrivateFieldGet(this, _ZonedTime_plainTime, "f").minute;
    }
    get second() {
        return __classPrivateFieldGet(this, _ZonedTime_plainTime, "f").second;
    }
    get millisecond() {
        return __classPrivateFieldGet(this, _ZonedTime_plainTime, "f").millisecond;
    }
    get microsecond() {
        return __classPrivateFieldGet(this, _ZonedTime_plainTime, "f").microsecond;
    }
    get nanosecond() {
        return __classPrivateFieldGet(this, _ZonedTime_plainTime, "f").nanosecond;
    }
    get timeZone() {
        return __classPrivateFieldGet(this, _ZonedTime_timeZone, "f").toString();
    }
    getTimeZone() {
        return __classPrivateFieldGet(this, _ZonedTime_timeZone, "f");
    }
    toString() {
        return `${__classPrivateFieldGet(this, _ZonedTime_plainTime, "f").toString()}[${this.timeZone}]`;
    }
    toJSON() {
        return this.toString();
    }
    round(roundTo) {
        const { isoHour, isoMinute, isoSecond, isoMillisecond, isoMicrosecond, isoNanosecond, } = __classPrivateFieldGet(this, _ZonedTime_plainTime, "f").round(roundTo).getISOFields();
        return new ZonedTime(isoHour, isoMinute, isoSecond, isoMillisecond, isoMicrosecond, isoNanosecond, __classPrivateFieldGet(this, _ZonedTime_timeZone, "f").toString());
    }
    getISOFields() {
        return {
            ...__classPrivateFieldGet(this, _ZonedTime_plainTime, "f").getISOFields(),
            timeZone: __classPrivateFieldGet(this, _ZonedTime_timeZone, "f").toString(),
        };
    }
    toLocaleString() {
        return [__classPrivateFieldGet(this, _ZonedTime_plainTime, "f").toLocaleString(), this.timeZone.toString()].join(' ');
    }
}
_ZonedTime_plainTime = new WeakMap(), _ZonedTime_timeZone = new WeakMap();
//# sourceMappingURL=zoned-time.js.map